module.exports = __webpack_public_path__ + "static/ron1-97c07385043c6f89ca5ff646e7096b1a.jpg";